import { useQuery } from "@tanstack/react-query";
import { api, type ChannelCommand, type Uuid } from "@shared/api";
import type { MenuItem } from "@shared/ui/Menu";
import { useInteractions } from "./interactions";

/**
 * Команды ботов канала — для меню человека и сообщения, «Приложения» в Discord.
 * Поле ввода держит свой запас; здесь — тот же запрос, по требованию меню.
 */
export function useChannelCommands(channelId: Uuid | null, enabled = true): ChannelCommand[] {
  const { data } = useQuery({
    queryKey: ["commands", channelId],
    queryFn: () =>
      api.commands
        .list(channelId!)
        .then((value) => value.items)
        .catch(() => [] as ChannelCommand[]),
    enabled: !!channelId && enabled,
    staleTime: 60_000,
  });
  return data ?? [];
}

/**
 * «Приложения» — команды меню (тип 2 — на человека, 3 — на сообщение), как в
 * Discord. Вызов уходит боту с целью, ответ ждём, как у команды поля ввода.
 * Пусто — пункта в меню нет.
 */
export function appItems(
  commands: readonly ChannelCommand[],
  type: 2 | 3,
  channelId: Uuid,
  targetId: Uuid,
  threadId: Uuid | null = null,
): MenuItem[] {
  return commands
    .filter((command) => command.type === type)
    .map((command) => ({
      label: command.name,
      hint: command.application_name,
      onPick: () =>
        void api.commands
          .invoke(channelId, command.id, [], threadId, targetId)
          .then(({ id }) =>
            useInteractions.getState().sent({ id, channelId, name: command.name, slash: false, bot: command.bot }),
          )
          .catch(() => {}),
    }));
}
